import styled from 'styled-components';

export const UTMWrapper = styled.div`
    margin-left: 60px;
    max-width: 760px;
`;

export const AlertWrapper = styled.div`
    margin: 16px 0 24px;
`;

export const ManageIpsTabsWrapper = styled.div`
    margin-bottom: 24px;
`;
